var __default__ = {root:'m_849cf0da'};
export default __default__;